import { useQuery } from '@tanstack/react-query';
import { getConversationAppointment } from '../../services/chats';
import useUser from '../global/useUser';

interface Options {
  enabled?: boolean;
}

function useGetConversationAppointment(
  conversationId: string | null | undefined,
  appointmentId: string | null | undefined,
  { enabled = true }: Options = {},
) {
  const { user } = useUser();

  const isEnabled =
    !!conversationId &&
    !!appointmentId &&
    !!user?.userId &&
    !!user?.business?.id &&
    enabled;

  const {
    data,
    isPlaceholderData,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: [
      'chat-conversation-appointment',
      user?.userId,
      user?.business?.id,
      conversationId,
      appointmentId,
    ],
    queryFn: async () => {
      const result = await getConversationAppointment(
        conversationId!,
        appointmentId!,
      );
      return result;
    },
    enabled: isEnabled,
  });

  return {
    data,
    isPlaceholderData,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
    isEnabled,
  };
}

export default useGetConversationAppointment;
